import React from "react";
import { Button } from "@mui/material";

const ErrorPage = ({ error, resetErrorBoundary }) => {
  return (
    <div className="md-error-page">
      <h1>
        The app contains some Error. please reload your page and try again!
      </h1>
      <p>{error?.message}</p>
      <Button
        sx={{ width: "200px" }}
        variant="contained"
        color="primary"
        onClick={resetErrorBoundary}
      >
        reload
      </Button>
    </div>
  );
};

export default ErrorPage;
